import { CompanyStatus, DrawerFilterType, DrawerFilter } from '../models';

export const userFilters: DrawerFilter[] = [
  {
    name: 'status',
    label: 'Status',
    type: DrawerFilterType.SELECT,
    value: CompanyStatus.ACTIVE,
    list: [
      {
        value: CompanyStatus.ACTIVE,
        text: 'Active',
      },
      {
        value: CompanyStatus.INACTIVE,
        text: 'Inactive',
      },
      {
        value: CompanyStatus.PENDING,
        text: 'Pending',
      },
    ],
  },
];
